import { FilterBuilder } from '../Types';

import { TypeValue } from 'ha/types/SearchFilters';

const kindAndTypeBuilder: FilterBuilder = ({ categories = [] }) => {
  if (categories.length === 1) {
    switch (categories[0]) {
      case TypeValue.PRIVATE_ROOM:
        return 'kind:PRIVATE_ROOM';
      case TypeValue.SHARED_ROOM:
        return 'kind:SHARED_ROOM';
      case TypeValue.APARTMENT:
        return 'kind:ENTIRE_PLACE AND type:APARTMENT AND NOT facility_bedroom_count:0';
      case TypeValue.STUDIO:
        return 'facility_bedroom_count:0';
      default:
        return '';
    }
  }

  if (categories.length === 2) {
    if (
      categories.includes(TypeValue.PRIVATE_ROOM) &&
      categories.includes(TypeValue.APARTMENT)
    ) {
      return '(NOT facility_bedroom_count:0 AND NOT kind:SHARED_ROOM)';
    }

    if (
      categories.includes(TypeValue.SHARED_ROOM) &&
      categories.includes(TypeValue.APARTMENT)
    ) {
      return 'NOT facility_bedroom_count:0 AND NOT kind:PRIVATE_ROOM';
    }

    if (
      categories.includes(TypeValue.APARTMENT) &&
      categories.includes(TypeValue.STUDIO)
    ) {
      return 'NOT kind:PRIVATE_ROOM AND NOT kind:SHARED_ROOM';
    }

    if (
      categories.includes(TypeValue.PRIVATE_ROOM) &&
      categories.includes(TypeValue.STUDIO)
    ) {
      return '(kind:PRIVATE_ROOM OR facility_bedroom_count:0)';
    }

    if (
      categories.includes(TypeValue.SHARED_ROOM) &&
      categories.includes(TypeValue.STUDIO)
    ) {
      return '(kind:SHARED_ROOM OR facility_bedroom_count:0)';
    }

    if (
      categories.includes(TypeValue.PRIVATE_ROOM) &&
      categories.includes(TypeValue.SHARED_ROOM)
    ) {
      return '(kind:SHARED_ROOM OR kind:PRIVATE_ROOM)';
    }
  }

  if (categories.length === 3) {
    if (!categories.includes(TypeValue.APARTMENT)) {
      return '(kind:PRIVATE_ROOM OR kind:SHARED_ROOM OR facility_bedroom_count:0)';
    }

    if (!categories.includes(TypeValue.PRIVATE_ROOM)) {
      return 'NOT kind:PRIVATE_ROOM';
    }

    if (!categories.includes(TypeValue.SHARED_ROOM)) {
      return 'NOT kind:SHARED_ROOM';
    }

    if (!categories.includes(TypeValue.STUDIO)) {
      return 'NOT facility_bedroom_count:0';
    }
  }

  return '';
};

export default kindAndTypeBuilder;
